<template>
	<div class="article-dt">
		<div class="contanier" v-if="artilce">
			<h2 class="art-title">{{artilce.title}}</h2>
			<div class="art-time" v-if="artilce.addtime">文章发布于{{artilce.addtime}}</div>
			<div class="art-content" v-html="artilce.content"></div>
		</div>
		<div v-else>
			<img src="../assets/image/no.png" alt="" class="banner no-data">
		</div>
	</div>
</template>

<script>
	export default {

		data: () => {
			return {
				artilce: {},
			}
		},
		mounted() {
			//获取服务器数据
			var id = this.$route.query.id;
			this.id = id;
			console.log('id', id)
			this.axios.get("getArticleInfo?id=" + id).then(res => {
				if (res.data.code == 'success') {
					this.artilce = res.data.data;
				}
			})
		},
		watch: {
			$route(val) {
				var id = val.query.id;
				if(id && id!='undefined'){
					this.id = id;
					console.log('id', id)
					this.axios.get("getArticleInfo?id=" + id).then(res => {					
						if (res.data.code == 'success') {
							this.artilce = res.data.data;
						}
					})
				}	
			}
		}
	}
</script>

<style lang="less">
	.article-dt {
		min-height: 500px;
		.art-title {
			text-align: center;
			padding: 30px 0px 15px 0px;
			
		}

		.art-time {
			text-align: center;
			font-weight: 300;
			margin-bottom: 15px;
			font-size: 14px;
		}

		.art-content {
			padding-bottom: 30px;
			min-height: 460px;
			line-height: 30px;
			font-weight: 300;
		}
		.no-data{
			display: block;
			margin: 100px auto;
			width: 250px;
		}
	}
</style>
